import { render } from "./EditDeletePrizeDrawClient.vue?vue&type=template&id=e0a20b5c"
import script from "./EditDeletePrizeDrawClient.vue?vue&type=script&lang=js"
export * from "./EditDeletePrizeDrawClient.vue?vue&type=script&lang=js"

import "./EditDeletePrizeDrawClient.vue?vue&type=style&index=0&id=e0a20b5c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__